<template>
  <div class="d-flex flex-wrap justify-content-between align-items-center">
    <b-button
      v-if="qType == '0'"
      variant="gradient-secondary"
      class="d-flex align-items-center"
      @click="addOption"
    >
      <span class="mr-1">گزینه</span>
      <feather-icon icon="PlusIcon" />
    </b-button>
    <div class="w-100">
      <draggable
        v-if="(qType == '0' || qType == '1') && items.length"
        v-model="items"
        class="list-group list-group-flush cursor-move"
        tag="ul"
      >
        <b-list-group-item
          v-for="(item, itemIndex) in items"
          :key="'option-' + itemIndex"
          tag="li"
        >
          <div class="d-flex">
            <span class="d-flex align-items-center mr-2 font-weight-bold"
              >{{ itemIndex + 1 }}.</span
            >

            <b-form-group label="متن گزینه" label-for="option" class="w-100">
              <validation-provider
                #default="{ errors }"
                name="option"
                vid="option"
                rules="required"
              >
                <b-form-input
                  autocomplete="on"
                  id="option"
                  v-model="item.value"
                  name="option"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="d-flex justify-content-between w-100">
            <b-button
              v-if="qType == '0'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              size="sm"
              class="btn-icon rounded-circle"
              @click="removeOption(itemIndex)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
            <b-form-radio
              v-model="correctAnswer"
              :name="'correct-answer-' + qIndex"
              :value="itemIndex"
            >
              جواب صحیح
            </b-form-radio>
          </div>
        </b-list-group-item>
      </draggable>
      <div v-if="qType == 3 && items.length">
        <b-form-group label="جواب صحیح" label-for="option">
          <validation-provider
            #default="{ errors }"
            name="option"
            vid="option"
            class="d-flex"
          >
            <b-form-radio
              v-for="(item, index) in items"
              :key="index"
              v-model="correctAnswer"
              :name="'correct-answer-' + qIndex"
              class="mx-2 my-1"
              :value="index"
            >
              {{ item.value }}
            </b-form-radio>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
  BListGroupItem,
  BFormRadio,
  BFormFile,
} from "bootstrap-vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import Editor from "@/@core/components/editor/Editor.vue";

export default {
  components: {
    BButton,
    SelectBox,
    BFormGroup,
    BListGroupItem,
    ValidationProvider,
    ValidationObserver,
    BFormRadio,
    BFormInput,
    BBadge,
    draggable,
    Editor,
    BFormFile,
  },
  data() {
    return {
      required,
      loader: false,
      items: [],

      correctAnswer: 0,
      value: "",
    };
  },
  directives: {
    Ripple,
  },
  props: {
    qType: {
      type: String,
      default: "",
    },
    qIndex: {
      type: String,
      default: "",
    },
    propItems: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    addOption() {
      this.items.push({ value: "", is_correct: 0 });
    },
    removeOption(index) {
      this.items.splice(index, 1);
    },
  },
  created() {
    if (this.propItems.length) {
      this.items = [...this.propItems];
      this.items.map((item, index) => {
        item.is_correct == 1 ? (this.correctAnswer = index) : "";
      });
    } else {
      if (this.qType == 1) {
        for (let i = 1; i <= 4; i++) {
          this.items[i - 1] = { value: "", is_correct: 0 };
        }
      } else if (this.qType == 0) {
        this.items = [];
      } else if (this.qType == 3)
        this.items = [{ value: "بله" }, { value: "خیر" }];
    }
  },
  watch: {
    qType(newVal) {
      if (this.propItems.length) {
        this.items = [...this.propItems];
        this.items.map((item, index) => {
          item.is_correct == 1 ? (this.correctAnswer = index) : "";
        });
      } else {
        if (this.qType == 1) {
          for (let i = 1; i <= 4; i++) {
            this.items[i - 1] = { value: "", is_correct: 0 };
          }
        } else if (this.qType == 0) {
          this.items = [];
        } else if (this.qType == 3)
          this.items = [{ value: "بله" }, { value: "خیر" }];
      }
    },
    items: {
      async handler(newVal) {
        await newVal.forEach((item, index) => {
          this.correctAnswer == index
            ? (item.is_correct = 1)
            : (item.is_correct = 0);
        });
        this.$emit("input", newVal);
      },
      deep: true,
      immediate: true,
    },
    async correctAnswer(val) {
      await this.items.forEach((item, index) => {
        val == index ? (item.is_correct = 1) : (item.is_correct = 0);
      });
    },
  },
};
</script>
